/**
 * Style d'une box « Choix » du proposal → style CSS du bloc web.
 *
 * Transposition de `getStyle()` (`components/common/SelectorVariable.jsx:144`),
 * en pur, pour être testable sans monter Draft.js ni le store.
 */

const DEFAULTS = {
  fontSize: 14,
  fontFamily: 'Montserrat',
  position: 'start',
  separator: '-',
  borderRadius: 0,
  bordersSize: 1,
  paddingTopBottom: 0,
  paddingLeftRight: 0,
};

/** Résout `{ label, style }` ou une chaîne en valeur CSS. */
function colorValue(color) {
  if (!color) return null;
  return typeof color === 'string' ? color : (color.style || null);
}

/** Le style d'identifiant donné, ou `null` si le document ne l'a plus. */
export function findSelectorStyle(selectorStyles, selectorStyleId) {
  if (!Array.isArray(selectorStyles)) return null;
  return selectorStyles.find((s) => String(s?.id) === String(selectorStyleId)) || null;
}

/**
 * Séparateur affiché entre deux options retenues. Un saut de ligne reste nu ;
 * tout autre séparateur s'entoure d'espaces, comme dans le proposal.
 */
export function selectorSeparator(styleDef) {
  const raw = styleDef?.separator ?? DEFAULTS.separator;
  return raw === '\n' ? raw : ` ${raw} `;
}

/** Style CSS de la boîte, défauts du proposal appliqués champ par champ. */
export function selectorBoxStyle(styleDef) {
  const s = styleDef || {};
  const borderColor = colorValue(s.borderColor) || 'transparent';
  const bordersSize = Number(s.bordersSize ?? DEFAULTS.bordersSize);
  return {
    backgroundColor: colorValue(s.backgroundColor) || undefined,
    borderRadius: Number(s.borderRadius ?? DEFAULTS.borderRadius),
    padding: `${Number(s.paddingTopBottom ?? DEFAULTS.paddingTopBottom)}px `
      + `${Number(s.paddingLeftRight ?? DEFAULTS.paddingLeftRight)}px`,
    border: `${bordersSize}px solid ${borderColor}`,
    color: colorValue(s.color) || undefined,
    fontSize: `${Number(s.fontSize || DEFAULTS.fontSize)}px`,
    fontFamily: `${s.fontFamily || DEFAULTS.fontFamily}, sans-serif`,
    fontWeight: s.fontWeight || undefined,
    fontStyle: s.fontStyle || undefined,
    textDecoration: s.textDecoration || undefined,
    justifyContent: s.position || DEFAULTS.position,
  };
}
